import { defineComponent as _defineComponent } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Calendar from 'primevue/calendar';
import SoilDetails from './Details.vue';
import { computed, onMounted, ref } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { useMitt } from '../../../Plugins/mitt';
import RecordsTableHeader from '../../../Components/RecordsTableHeader.vue';
import { concatPlotsCodes, formatISODate } from '../../../Services/Utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const selectedRecords = ref([]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            plots: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
            },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code', 'plots', 'description'];
        const itemDetails = ref();
        const detailsVisible = ref(false);
        const page = usePage();
        const soilDatas = computed(() => page.props.value.soilDatas || []);
        const reloadRecords = () => {
            Inertia.reload({
                only: ['soilDatas'],
            });
        };
        onMounted(() => reloadRecords());
        const edit = (data) => {
            emitter.emit('open-soil-data-form', data);
        };
        emitter.on('soil-data-saved', () => reloadRecords());
        const __returned__ = { emitter, selectedRecords, filters, globalFilterFields, itemDetails, detailsVisible, page, soilDatas, reloadRecords, edit, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get Calendar() { return Calendar; }, SoilDetails, RecordsTableHeader, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
